import foto1 from "url:../fotos/gallery/1.jpg";
import foto2 from "url:../fotos/gallery/2.jpg";
import foto3 from "url:../fotos/gallery/3.jpg";
import foto4 from "url:../fotos/gallery/4.jpg";
import foto5 from "url:../fotos/gallery/5.jpg";
import foto6 from "url:../fotos/gallery/6.jpg";
import foto7 from "url:../fotos/gallery/7.jpg";
import foto8 from "url:../fotos/gallery/8.jpg";
import foto9 from "url:../fotos/gallery/9.jpg";

const CONFIG = {
  // ── Fechas y lugar ──────────────────────────────────────────
  // Formato ISO: 'YYYY-MM-DDTHH:MM:SS'
  weddingDate: "2026-10-24T15:00:00",

  // ── Colores del degradado de fondo (deben coincidir con el CSS) ──
  // Se interpolan en scroll entre secciones claras y oscuras.
  gradientLight: [250, 247, 242], // --ivory
  gradientDark: [44, 36, 25], // --charcoal

  // ── Secciones y si su fondo dominante es claro u oscuro ──────
  gradientSections: [
    { id: "hero", light: false },
    { id: "personal-card", light: false },
    { id: "countdown", light: false },
    { id: "gallery", light: true },
    { id: "dresscode", light: false },
    { id: "itinerary", light: true },
    { id: "notices", light: true },
    { id: "location", light: false },
    { id: "rsvp", light: true },
  ],
  galleryPhotos: [
    { src: foto1, caption: "" },
    { src: foto2, caption: "" },
    { src: foto3, caption: "" },
    { src: foto4, caption: "" },
    { src: foto5, caption: "" },
    { src: foto6, caption: "" },
    { src: foto7, caption: "" },
    { src: foto8, caption: "" },
    { src: foto9, caption: "" },
  ],
  // ── Testing Mode? ───────────────────────────────────────────────
  // Sirve para visualizar lo que veria un invitado al entrar a la pagina
  testingMode: false,
};

window.CONFIG = CONFIG;